import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'

import { cn } from '@/lib/utils'

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'tap-target peer data-[state=checked]:text-background relative grid size-4 shrink-0 place-items-center focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        'before:border-input before:absolute before:top-1/2 before:left-1/2 before:size-4 before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-sm before:border before:content-[""]',
        'data-[state=checked]:before:border-foreground data-[state=checked]:before:bg-foreground focus-visible:before:ring-ring/50 focus-visible:before:ring-[3px]',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="relative flex items-center justify-center text-current">
        <Check className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
